import { app } from '../../../bootstrap/core';
import { cardComponent } from './card.component';
import { CardStates, IconMappings } from './card.constants';
import { CardModel } from './card.model';
import { CardService } from './card.service';
import { CardBuildingService } from './card.building.service';
import './cardFooter/cardFooter';
import './cardHeader/cardHeader';

app.component('card', cardComponent);
app.service('cardService', CardService);
app.service('cardBuildingService', CardBuildingService);
app.constant('CardStates', CardStates);
app.constant('IconMappings', IconMappings);
app.constant('CardModel', CardModel);
